import cookies from 'js-cookie'

const OverviewSwitcher = () => {
  const pathName = window.location.pathname
  if (pathName !== '/overview' && pathName !== '/moderation/overview') {
    return <div />
  }
  const linkUrl = pathName === '/overview' ? '/moderation/overview' : '/overview'
  const linkClass = pathName === '/overview' ? 'overview-switcher-old-link-text' : ''
  const linkText = pathName === '/overview' ? 'Switch to old version' : 'Switch to new version'

  return (
    <div class='overview-switcher'>
      <a href={linkUrl} class={linkClass} onClick={() => switchLink()}>
        {linkText}
      </a>
    </div>
  )

  function switchLink() {
    cookies.set('old_moderation_overview', '0')
    if (window.location.pathname === '/overview') {
      cookies.set('old_moderation_overview', '1')
    }
  }
}

export default OverviewSwitcher
